// extracted by mini-css-extract-plugin
module.exports = {"pageMark":"PageMark_pageMark__3b7HD"};